import { render, staticRenderFns } from "./infoBox.vue?vue&type=template&id=87cfece6&scoped=true&"
import script from "./infoBox.vue?vue&type=script&lang=js&"
export * from "./infoBox.vue?vue&type=script&lang=js&"
import style0 from "./infoBox.vue?vue&type=style&index=0&id=87cfece6&lang=scss&scoped=true&"
import style1 from "./infoBox.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87cfece6",
  null
  
)

export default component.exports